import React from 'react';

/**
 * Mobile model selector component with previous/next navigation
 * 
 * @param {Object} props - Component props
 * @param {Array} props.models - Array of model objects
 * @param {number} props.selectedIndex - Currently selected model index
 * @param {Function} props.setSelectedIndex - Function to update selected model
 */
const ModelSelector = ({ models, selectedIndex, setSelectedIndex }) => {
  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2">
        <button 
          className="p-2 bg-gray-100 rounded-full disabled:opacity-50"
          onClick={() => setSelectedIndex(prev => prev > 0 ? prev - 1 : prev)}
          disabled={selectedIndex === 0}
          aria-label="Previous model"
        >
          ◀
        </button>
        <div className="text-center font-medium">
          {models[selectedIndex].name}
        </div>
        <button 
          className="p-2 bg-gray-100 rounded-full disabled:opacity-50"
          onClick={() => setSelectedIndex(prev => prev < models.length - 1 ? prev + 1 : prev)}
          disabled={selectedIndex === models.length - 1}
          aria-label="Next model"
        >
          ▶
        </button>
      </div>
      <div className="text-center text-sm">
        Model {selectedIndex + 1} of {models.length}
      </div>
    </div>
  );
};

export default ModelSelector;
